import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewName extends React.Component {

  textFieldDidEndEditing(e) {
    this.props.delegate.changeName(e.currentTarget.name, e.currentTarget.value);
  }
  
  render() {
    const reservation = this.props.reservation;
    const errors = this.props.errors;
    
    return (
      <td>
        姓 <SMFormTextField name="reserved_user[family_name]"
          options={{className:'w110 mr10'}}
          value={reservation.user && reservation.user.family_name != undefined ? reservation.user.family_name : ''}
          placeholderText="佐藤"
          delegate={this} />
        名 <SMFormTextField name="reserved_user[given_name]"
          options={{className:'w110'}}
          value={reservation.user && reservation.user.given_name != undefined ? reservation.user.given_name : ''}
          placeholderText="太郎"
          delegate={this} />
        <span className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'reservation_user.family_name', errors)}</span>
        <span className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'reservation_user.given_name', errors)}</span>
      </td>
    );
  }
}

SMReservationEditViewName.propTypes = {
  reservation: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewName;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewName.jsx